<script lang="ts" setup>
import type { ChapterConfig } from '../configs/types'
import { getChapterConfig } from '../configs/brands'
import { SubscriptionCycle } from '@/utils/enum'
import { VIP_TYPE } from '@/constants'
import { useI18n } from '@/composables/useI18n'
import { brand } from '@/config/brands'

const props = defineProps<{
  item: any
  getUnitPrice: (item: any) => string | number
  isZero: (value: any) => boolean
}>()

const { t } = useI18n()

// 加载当前品牌的 chapter 配置
const config: ChapterConfig = getChapterConfig()
</script>

<template>
  <div class="relative w-full h-full px-12px pt-20px pb-20px text-n-text-1">
    <!-- 角标 -->
    <div v-if="item.cornerTip === 1 && item.marketingCopy" class="popular-tag">
      {{ item.marketingCopy }}
    </div>

    <!-- 折扣会员 -->
    <div v-if="item.subscribeType === VIP_TYPE.DISCOUNT" class="flex items-center">
      <!-- 折扣会员的周期背景,例如: Weekly -->
      <div class="cycleBg absolute font-bold top-0 right-0 text-32px leading-[30px] text-n-primary">
        {{ item.cycleStr }}
      </div>

      <img v-if="config.colors.showVipIcon" :src="brand === 'talewave' ? '/images/talewave/vip/tw_ic_vip.png' : `@/assets/vip_discount.png`" class="w-26px! flex-shrink-0">
      <div class="flex-1 ml-16px">
        <div class="text-18px font-medium">
          {{ item.discountCoins }} Coins
        </div>
        <ul class="text-n-primary text-12px list-disc pl-12px">
          <li>{{ t('SET', { 0: item.discountOnceCoins }) }}</li>
          <li>{{ t('SET2', { 0: item.discountBonusCoins, 1: item.discountDailyCoins }) }}</li>
        </ul>
      </div>
      <div class="flex-shrink-0 text-right relative">
        <div class="text-18px font-bold">
          $ {{ item.preferentialPrice || item.price }}
        </div>
        <div class="text-n-text-2 text-12px line-through">
          $ {{ item.discountOriginalPrice }}
        </div>
      </div>
    </div>

    <!-- 畅读会员 -->
    <div v-else class="flex items-center relative h-full">
      <div v-if="config.colors.showVipIcon" class="flex-shrink-0">
        <img src="@/assets/vip_icon2.png" class="w-26px!">
      </div>

      <div class="flex-1 ml-8px flex flex-col justify-start">
        <div class="text-18px font-medium">
          {{ SubscriptionCycle.getItemByValue(item.cycle)?.label }}
        </div>
        <div class="text-n-primary truncate-2-lines">
          {{ item.subscribeText }}
        </div>
      </div>

      <!-- 免费 -->
      <div v-if="isZero(item.preferentialPrice)">
        <div class="text-18px font-bold">
          {{ config.texts.payTemplateFree }}
        </div>
        <div class="text-n-text-2 text-12px line-through text-right">
          $ {{ item.price }}
        </div>
      </div>

      <!-- 无优惠价格 -->
      <div v-else-if="!item.preferentialPrice" class="flex-shrink-0 text-right relative">
        <div class="text-18px font-bold">
          $ {{ item.price }}
        </div>

        <div v-if="getUnitPrice(item)" class="text-n-text-2 text-12px">
          $ {{ getUnitPrice(item) }}
        </div>
      </div>

      <!-- 有优惠价格 -->
      <div v-else>
        <div class="text-18px font-bold">
          $ {{ item.preferentialPrice }}
        </div>
        <div class="text-n-text-2 text-12px line-through text-right">
          $ {{ item.price }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.truncate-2-lines {
  width: 100%;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}
</style>
